import React from 'react'
import { useTrans } from 'hooks'
import { WImage, Button } from 'react-components/atoms'

const FormazioneModuloCardProfilo = props => {
  const { item = undefined, className = '' } = props
  const t = useTrans()

  const handleGTM = label => {
    dataLayer.push({
      event: 'GAevent',
      eventID: '36',
      eventCategory: 'formazione_area_riservata',
      eventAction: label.toGTMFormat(),
      eventLabel: item.titolo.toGTMFormat(),
      moreInfo: item.in_corso ? 'moduli_in_corso' : 'moduli_conclusi',
    })
  }

  return item ? (
    <div
      className={`formazione-modulo-card ${
        item.iscrizioneAttiva ? ' formazione-modulo-card--iscrizione' : ''
      } ${item.in_corso ? '' : ' formazione-modulo-card--concluso'} ${
        className ? ` ${className}` : ''
      }`}
    >
      <div className="formazione-modulo-card-profilo__head">
        <div className="formazione-modulo-card-profilo__head__image">
          <WImage src={item.main_image} maxHeight={120} alt={item.titolo} title={item.titolo} />
        </div>
        <div className="formazione-modulo-card-profilo__head__container">
          <p className="formazione-modulo-card-profilo__head__container__intro">
            {item.nome_corso}
          </p>
          <p className="formazione-modulo-card-profilo__head__container__title">{item.titolo}</p>
        </div>
      </div>
      <div className="formazione-modulo-card-profilo__content">
        <div className="formazione-modulo-card-profilo__content__cta-box">
          {item.link_questionario ? (
            <Button
              label={t('Scarica attestato')}
              href={item.link_questionario}
              newPage
              external
              onClick={() => handleGTM(t('Scarica attestato'))}
            />
          ) : (
            <></>
          )}

          <Button
            variant="secondary"
            label={t('Vedi materiali')}
            href={item.url}
            onClick={() => handleGTM(t('Vedi materiali'))}
          />
        </div>
      </div>
    </div>
  ) : (
    <></>
  )
}

export default FormazioneModuloCardProfilo
